<template>
  <div>
    <div class="is-block has-text-weight-normal mb-2">
      {{$filters.fullDateTime(activity.timeStamp || activity?.at)}}
      <span v-if="userAgent.getBrowser().name">
        from {{userAgent.getBrowser().name}} on {{userAgent.getOS().name}}
      </span>
      <span class="is-pulled-right">
        <i :class="!change ? 'icon-disclosearrow':
          'icon-disclosearrowup'" class="pointer has-text-primary"
          @click="isCollapsed()" v-if="activity.messages.length > 0">
        </i>
      </span>
    </div>
    <div class="has-text-weight-bold mb-2 has-text-black-bis">
      <template v-if="activity.action === 'Login'">
        {{ getUserDisplayName }} logged in
      </template>
      <template v-else>
        {{ getUserDisplayName }} made following changes to {{ module[activity.subModule] || activity.subModule || '' }}
      </template>
    </div>
    <ul
          v-if="change"
          v-for="(message,index) in activity.messages"
          :key="index" class="list-style"
    >
      <div v-if="$_.isArray(message)">
        <div class="has-text-black-bis">
          {{ message[0] }}
        </div>
        <ul v-if="message[1] && message[1].length > 0"
          v-for="(subMessage, subIndex) in message[1]"
          :key="subIndex" class="list-style"
          >
          <li>
            <span v-html="subMessage"></span>
          </li>
        </ul>
      </div>
      <li v-else>
        <span v-html="message.text || message"></span>
      </li>
    </ul>
  </div>
</template>

<script>

import { computed, defineComponent, reactive, toRefs } from 'vue';
import UAParser from 'ua-parser-js';

export default defineComponent({
  name: 'ActivityStatement',
  props: ['activity', 'showFirst'],
  setup(props) {
    const state = reactive({
      change: props.showFirst || false,
    });

    const module = {
      'app_settings::manufacton_settings::custom_fields::po_order': 'Custom Fields Production Orders',
      'app_settings::manufacton_settings::custom_fields::sl_order': 'Custom Fields Shipping Orders',
      'app_settings::manufacton_settings::custom_fields::po_item': 'Custom Fields Production Order Items',
      'app_settings::manufacton_settings::custom_fields::sl_delivery': 'Custom Fields Shipping Delivery Items',
    }

    const isCollapsed = () => {
      state.change = !state.change;
    };

    const userAgent = computed(() => {
      const parser = new UAParser();
      return parser.setUA(props.activity.userAgent);
    })

    const getUserDisplayName = computed(() => {
      return props.activity?.userData?.fullName
        || props.activity?.activityUser?.fullName
        || 'Unknown User';
    });

    return {
      ...toRefs(state),
      isCollapsed,
      module,
      userAgent,
      getUserDisplayName,
    };
  }
})



</script>
